module.exports = __webpack_public_path__ + "static/media/cateringPreslava.ff84fec3.png";